<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-h9`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 5a1 1 0 011 1v16h17V6a1 1 0 011-1h2a1 1 0 011 1v36a1 1 0 01-1 1h-2a1 1 0 01-1-1V26H6v16a1 1 0 01-1 1H3a1 1 0 01-1-1V6a1 1 0 011-1h2zm32.267 11.878c1.632 0 3.131.46 4.486 1.375 1.357.917 2.388 2.224 3.087 3.907.692 1.668 1.032 4.037 1.032 7.117 0 3.195-.336 5.752-1.014 7.677-.688 1.953-1.722 3.454-3.101 4.49C40.375 42.481 38.755 43 36.912 43c-1.964 0-3.59-.575-4.857-1.729-1.137-1.035-1.864-2.442-2.183-4.2l-.018-.11a1 1 0 01.837-1.14l.056-.007 1.863-.18a.942.942 0 01.983.636l.028.105c.23 1.07.609 1.839 1.125 2.315.57.526 1.306.79 2.23.79.803 0 1.495-.187 2.085-.56a4.598 4.598 0 001.489-1.534c.398-.657.739-1.566 1.017-2.722.21-.875.342-1.761.394-2.66a7.495 7.495 0 01-1.618 1.285 6.754 6.754 0 01-3.512.965c-2.091 0-3.876-.795-5.324-2.372-1.447-1.577-2.169-3.65-2.169-6.19 0-2.62.753-4.756 2.26-6.376 1.508-1.622 3.408-2.438 5.669-2.438zm-2.643 5.008c.863-.989 1.853-1.471 2.997-1.471 1.103 0 2.035.444 2.828 1.354.797.914 1.2 2.163 1.2 3.772 0 1.61-.392 2.838-1.165 3.711-.769.869-1.739 1.298-2.944 1.298-1.197 0-2.186-.432-3-1.307-.813-.876-1.22-2.017-1.22-3.45 0-1.62.435-2.912 1.304-3.907z"/></svg>
</template>
<script>

export default {
  name: 'IconH9',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
